export const BROOBEE_DECIMALS = 18;
export const CAKE_DECIMALS = 18;
export const BROOBEE_BNB_DECIMALS = 18;
export const DEFAULT_DECIMALS = 18;
